import { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/core/helpers/cn";

type Props = {
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export default function InventoryContent({ children, ...attrs }: Props) {
  const { className, ...other } = attrs;
  return (
    <div
      className={cn(
        "shrink-0 px-7.5",
        "[--scrollbar-track-bg:#181818] [--scrollbar-thumb-bg:#434242] [scrollbar-gutter:stable]",
        className,
      )}
      {...other}
    >
      {children}
    </div>
  );
}
